import { action, ActionType } from "typesafe-actions";
import { UsersSearchForm } from "../types/users-search-form.interface";
import { IUser } from "../../../types/user/iuser.interface";

export enum UsersActions {
  SearchUsers = "Users/Search",
  SearchUsersSuccess = "Users/SearchSuccess",
  SearchUsersFailure = "Users/SearchUsersFailure",
  ResetSearchResults = "Users/ResetSearchResults",
  FetchAllUsers = "Users/FetchAll",
  FetchAllUsersSuccess = "Users/FetchAllSuccess",
  FetchAllUsersFailure = "Users/FetchAllFailure",
}

export const searchUsers = (searchForm: UsersSearchForm) =>
  action(UsersActions.SearchUsers, searchForm);
export const searchUsersSuccess = (results: IUser[]) =>
  action(UsersActions.SearchUsersSuccess, results);
export const searchUsersFailure = (error: any) => action(UsersActions.SearchUsersFailure, error);
export const resetSearchResults = () => action(UsersActions.ResetSearchResults);

export const fetchAllUsers = () => action(UsersActions.FetchAllUsers);
export const fetchAllUsersSuccess = (users: IUser[]) =>
  action(UsersActions.FetchAllUsersSuccess, users);
export const fetchAllUsersFailure = (error: any) =>
  action(UsersActions.FetchAllUsersFailure, error);

const actionCreators = {
  searchUsers,
  searchUsersSuccess,
  searchUsersFailure,
  fetchAllUsers,
  fetchAllUsersSuccess,
  fetchAllUsersFailure,
  resetSearchResults,
};

export type UsersActionsType = ActionType<typeof actionCreators>;
